const headerData = [
  {
    icon: "./images/phone.png",
    title: "060-619135",
    text: "Vardagar 07.00 - 16.00",
  },
  {
    icon: "./images/pin.png",
    title: "Ortviksvägen 39",
    text: "85633, Sundsvall",
  },
  {
    icon: "./images/tires.png",
    title: "Verkstad & Rekond",
    text: "Boka din tid idag",
  },
];

const navLinks = [
  {
    page: "Hem",
    url: "/",
  },
  {
    page: "Tjänster",
    url: "/tjanster",
  },
  {
    page: "Däck & Fälg",
    url: "/dack&falg",
  },
  {
    page: "Tvätt & Rekond",
    url: "/tvatt&rekond",
  },
  {
    page: "Däckverkstad",
    url: "/dackverkstad",
  },
  {
    page: "Däckhotell",
    url: "/dackhotell",
  },
  {
    page: "Leverantörer",
    url: "/leverantorer",
  },
  {
    page: "Personal",
    url: "/personal",
  },
  {
    page: "Kontakt",
    url: "/kontakt",
  },
  {
    page: "Tips & Råd",
    url: "/tips",
  },
];

const sectionThree = [
  {
    title: "Däckverkstad",
    text: "Hos oss skiftar du däck tryggt och säkert. Vi bjuder på kaffe och kaka medans du väntar.",
    src: "./images/lug.png",
    link: "/dackverkstad",
  },
  {
    title: "Däckhotell",
    text: "Förvara dina hjul hos oss. Enkelt och bekvämt. Vi förvarar samtliga hjul i vårt nybyggda däckhotell och kan garantera att dina hjul förvaras på ett korrekt sätt.",

    src: "./images/wheel.png",
    link: "/dackhotell",
  },
  {
    title: "Däck & Fälg",
    text: "Vi erbjuder däck & fälg till alla bilar i olika prisklasser. Vi jobbar tillsammans med välkända och pålitliga leverantörer som Bridgestone, Nokian, Specialfälgar, OCL Brorssons & Rautamo.",

    src: "./images/tire.png",
    link: "/dack&falg",
  },
  {
    title: "Tvätt & Rekond",
    text: "Vår tvätt & rekond finns tillgänglig för dig året om. Vi utför allt ifrån enklare tvättare till hel rekonditionering och lackförseglningar, kontakta oss gärna om du har några speciella önskemål.",

    src: "./images/wash.png",
    link: "/tvatt&rekond",
  },
];

const sectionTwo = [
  {
    icon: "far fa-calendar-check",
    text: "Enkel och snabb bokning",
  },
  {
    icon: "fas fa-wrench",
    text: "Experter på däck, fälg",
  },
  {
    icon: "fas fa-coins",
    text: "Konkurrenskraftigt pris",
  },
  {
    icon: "far fa-handshake",
    text: "Däck till dina behov",
  },
];

const socialMedia = [
  {
    url: "https://www.facebook.com",
    icon: "fab fa-facebook-f",
  },
  {
    url: "https://www.instagram.com",
    icon: "fab fa-instagram",
  },
  {
    url: "https://www.twitter.com",
    icon: "fab fa-twitter",
  },
  {
    url: "https://www.linkedin.com",
    icon: "fab fa-linkedin-in",
  },
];

const boka = [
  {
    array: "boka",
    title: "Däckbyte",
    price: "295:-    ",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Medans du väntar skiftar vi dina däck. När du bokat ett däckskifte hos oss bör du ha med dig alla ev. extra bultar och eventuell låsbult. Detta för att vi ska kunna på ett snabbt och effektivt sätt skifta däcken.",
    img: "https://static.wixstatic.com/media/3a04ff_e9dbe96093b743bb857ab51594dff83e~mv2_d_1920_1280_s_2.jpg/v1/fill/w_554,h_300,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01/3a04ff_e9dbe96093b743bb857ab51594dff83e~mv2_d_1920_1280_s_2.webp",
  },
  {
    array: "boka",
    title: "VIP-Tvätt   ",
    price: "695:-    ",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Avfettning, högtryckspolning, schamponering, handtvätt, fälg & däck rengöring, torkning, rengöring av gummimattor & dörrgångar, paneler, dörrsidor, dammsugning av interiör & bagageutrymmet samt fönsterputs.    ",
    img: "https://o.aolcdn.com/images/dims?crop=4256%2C2392%2C0%2C219&quality=85&format=jpg&resize=800%2C450&image_uri=http%3A%2F%2Fo.aolcdn.com%2Fhss%2Fstorage%2Fmidas%2F376aa38a04f1432a63f9ef1757931760%2F206285963%2Fcar-washing-picture-id451803261&client=a1acac3e1b3290917d92&signature=625e5d13ca4cd5bf46f20f7dc4b867a9f4724e74",
  },

  {
    array: "boka",
    title: "Utvändig Handtvätt    ",
    price: "300:-    ",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Avfettning, högtrycksspolning, schamponering, handtvätt, fälg & däckrengöring, rengöring av mattor & dörrgångar samt torkning.    ",
    img: "http://ranchodeloro-carwash.com/wp-content/uploads/2014/02/slide1.jpg",
  },
  {
    array: "boka",
    title: "Balansering    ",
    price: "150:-    ",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Med hjälp av moderna maskiner balanserar vi dina hjul så du slipper obalans i hjul, ratt och bil.    ",
    img: "https://www.dackteam.se/wp-content/uploads/2019/04/D%C3%A4ckbalansering2.jpg",
  },
  {
    array: "boka",
    title: "Lackförsegling ",
    text: "Matrix Black NordicSilox 5D 9h keramiskt lackskydd",
    extraText:
      "Mycket långvarig effekt – 8 år (eller 24000 mil), Värmebeständig (700°C) och extrem vattenavvisning (120° kontaktvinkel)",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    price: "3000:-    ",
    special:
      "MATRIX NORDICSILOX är en produktserie med keramiska lackskydd som utvecklats med hjälp av den absolut senaste teknologin. Produkterna möjliggör att hålla din bil i nyskick längre, då de förbättrar varje detalj i lacken, allt ifrån ett ökat färgdjup till en fantastisk glans och lyster. Speciellt framtagna och noggrant testade av kemister med expertkunskap, möter produkterna kraven som ställs av såväl erfarna rekonditioneringsproffs som fordonsentusiaster. MATRIX keramiska lackskydd levererar oöverträffat resultat. Med upp till 8 års beständighet är det inget annat keramiskt lackskydd som kan svara upp när det gäller prestanda.MATRIX keramiska lackskydd ger ett skydd mot väder och vind, avnötning, temperatur, kemikalier och föroreningar genom att kraftigt binda mot ytan vilket förhindrar att det smälter, krackelerar eller försvinner.",
    img: "https://static.wixstatic.com/media/07eda6_0ee1339cc34648e69bf263a315df7d7b~mv2.jpg/v1/fill/w_640,h_400,al_c,q_80,usm_0.66_1.00_0.01/07eda6_0ee1339cc34648e69bf263a315df7d7b~mv2.webp",
  },
  {
    array: "boka",
    title: "Helrekond    ",
    price: "3900:-    ",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Med helrekond utför vi en in- & utvändig rekond. Bilen hantvättas utvändigt för att få bort smuts och beläggningar. Detta sker alltid för hand då vi vill garantera en skonsam och noggrann tvätt. När bilen är ren maskinpolerar vi den och lägger på ett vaxlager. Detta gör att smutsen som din bil utsätts för dagligen har svårare att fästa, som på längre sikt medföra slitage.    ",
    img: "https://baileyscarwashanddetailing.com/wp-content/uploads/2020/03/Interior-Cleaning-Northern-Kentucky-Burlington-Union.jpg",
  },
];

const däckPrisLista = [
  {
    array: "prisLista",
    title: "Däckskifte",
    price: "295:-",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Medans du väntar skiftar vi dina däck. När du bokat ett däckskifte hos oss bör du ha med dig alla ev. extra bultar och eventuell låsbult. Detta för att vi ska kunna på ett snabbt och effektivt sätt skifta däcken.    ",
    img: "https://static.wixstatic.com/media/3a04ff_e9dbe96093b743bb857ab51594dff83e~mv2_d_1920_1280_s_2.jpg/v1/fill/w_554,h_300,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01/3a04ff_e9dbe96093b743bb857ab51594dff83e~mv2_d_1920_1280_s_2.webp",
  },
  {
    array: "prisLista",
    title: "Däckhotell",
    price: "fr. 790:-",
    button: "Kontakta  oss",
    route: "/contact",
    text: "Förvara dina hjul hos oss. Enkelt och bekvämt. Vi förvarar samtliga hjul i vårt nybyggda däckhotell och kan garantera att dina hjul förvaras på ett korrekt sätt. I vårt däckhotell ingår alltid däckskifte, förvaring & tvätt. Vi går igenom samtliga förvaringshjul under lågsäsong och kontaktar er om däcken behöver bytas. ",
    img: "https://www.atteviks.se/wp-content/uploads/2019/05/da%CC%88ckhotell1.jpg",
  },
  {
    array: "prisLista",
    title: "Balansering    ",
    price: "150:-    ",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Med hjälp av moderna maskiner balanserar vi dina hjul så du slipper obalans i hjul, ratt och bil.    ",
    img: "https://www.dackteam.se/wp-content/uploads/2019/04/D%C3%A4ckbalansering2.jpg",
  },
  {
    array: "prisLista",
    title: "Montering",
    price: "150:-",
    button: "Kontakta oss",
    route: "/contact",
    text: "Med hjälp av nya moderna maskiner monterar vi säkert, snabbt och med högsta precision alla typer av däck. Vi monterar allt från små däck till känsliga 24”´s hjul. Med den senaste tekniken undviker vi så kallade monteringsskador som lätt kan uppstå då dagens däck blir allt känsligare.",
    img: "https://www.dackhusetlinkoping.se/images/2019/02/25/3block-02.jpg",
  },
];

const rekondPrisLista = [
  {
    array: "prisLista",
    title: "VIP-Tvätt   ",
    price: "695:-    ",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Avfettning, högtryckspolning, schamponering, handtvätt, fälg & däck rengöring, torkning, rengöring av gummimattor & dörrgångar, paneler, dörrsidor, dammsugning av interiör & bagageutrymmet samt fönsterputs.    ",
    img: "https://o.aolcdn.com/images/dims?crop=4256%2C2392%2C0%2C219&quality=85&format=jpg&resize=800%2C450&image_uri=http%3A%2F%2Fo.aolcdn.com%2Fhss%2Fstorage%2Fmidas%2F376aa38a04f1432a63f9ef1757931760%2F206285963%2Fcar-washing-picture-id451803261&client=a1acac3e1b3290917d92&signature=625e5d13ca4cd5bf46f20f7dc4b867a9f4724e74",
  },

  {
    array: "prisLista",
    title: "Utvändig Handtvätt    ",
    price: "300:-    ",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Avfettning, högtrycksspolning, schamponering, handtvätt, fälg & däckrengöring, rengöring av mattor & dörrgångar samt torkning.    ",
    img: "http://ranchodeloro-carwash.com/wp-content/uploads/2014/02/slide1.jpg",
  },

  {
    array: "prisLista",
    title: "Helrekond    ",
    price: "3900:-    ",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    text: "Med helrekond utför vi en in- & utvändig rekond. Bilen hantvättas utvändigt för att få bort smuts och beläggningar. Detta sker alltid för hand då vi vill garantera en skonsam och noggrann tvätt. När bilen är ren maskinpolerar vi den och lägger på ett vaxlager. Detta gör att smutsen som din bil utsätts för dagligen har svårare att fästa, som på längre sikt medföra slitage.    ",
    img: "https://baileyscarwashanddetailing.com/wp-content/uploads/2020/03/Interior-Cleaning-Northern-Kentucky-Burlington-Union.jpg",
  },
  {
    array: "prisLista",
    title: "Motortvätt    ",
    price: "200:-    ",
    button: "Kontakta oss",
    route: "/contact",
    text: "Vid motortvätten avfettas motorutrymmet och motorns delar så de blir fria från fett och olja. Vi undviker att rengöra eller spola vatten direkt på bilens elektronik.         ",
    img: "https://www.mafra.com/blog/wp-content/uploads/2017/08/shutterstock_387149560.jpg",
  },
  {
    array: "prisLista",
    title: "Invändig rekond    ",
    price: "2400:-",
    button: "Kontakta oss",
    route: "/contact",
    text: "Vid invändig rekond ingår bl.a dammsugning av kupé och bagageutrymme, tvätt av mattor, rengöring av dörrkarmar, klädsel och fack. När insidan av bilens alla skrymslen och vrår är väl rengjorda, impregnerar vi plast och klädsel för längre hållbarhet. Vi utför även en Motortvätt på din bil. Avslutningsvis putsas samtliga fönster.    ",
    img: "https://www.detailxperts.net/wp-content/uploads/2016/05/automobile-automotive-car-1104768-e1550891248114.jpg",
  },
  {
    array: "prisLista",
    title: "Lackförsegling ",
    text: "Matrix Black NordicSilox 5D 9h keramiskt lackskydd",
    extraText:
      "Mycket långvarig effekt – 8 år (eller 24000 mil), Värmebeständig (700°C) och extrem vattenavvisning (120° kontaktvinkel)",
    button: "Boka tid",
    route:
      "https://sedackservice.compilator.com/public/cms?Id=1&CompanyId=8b3db2d2-5663-437f-9099-c3d4b8ee5825&branchId=1",
    price: "3000:-    ",
    special:
      "Matrix Black NordicSilox 5D är ett 9h keramiskt lackskydd med en 8-års eller 24000 mils beständighet, extrem vattenavvisning med en 120° kontaktvinkel och 700°C värmebeständighet. MATRIX NORDICSILOX är en produktserie med keramiska lackskydd som utvecklats med hjälp av den absolut senaste teknologin. Produkterna möjliggör att hålla din bil i nyskick längre, då de förbättrar varje detalj i lacken, allt ifrån ett ökat färgdjup till en fantastisk glans och lyster. Speciellt framtagna och noggrant testade av kemister med expertkunskap, möter produkterna kraven som ställs av såväl erfarna rekonditioneringsproffs som fordonsentusiaster. MATRIX keramiska lackskydd levererar oöverträffat resultat. Med upp till 8 års beständighet är det inget annat keramiskt lackskydd som kan svara upp när det gäller prestanda.MATRIX keramiska lackskydd ger ett skydd mot väder och vind, avnötning, temperatur, kemikalier och föroreningar genom att kraftigt binda mot ytan vilket förhindrar att det smälter, krackelerar eller försvinner.",
    img: "https://static.wixstatic.com/media/07eda6_0ee1339cc34648e69bf263a315df7d7b~mv2.jpg/v1/fill/w_640,h_400,al_c,q_80,usm_0.66_1.00_0.01/07eda6_0ee1339cc34648e69bf263a315df7d7b~mv2.webp",
  },
];

const leverantörer = [
  {
    title: "Bridgestone",
    img: "https://i.pinimg.com/originals/ff/78/f3/ff78f300b4aa34790a3114274be22ee4.jpg",
    url: "https://www.bridgestone.se",
  },
  {
    title: "Nokian Tyres",
    img: "https://s19532.pcdn.co/wp-content/uploads/2017/12/Nokian-logo.jpg",
    url: "https://www.nokiantyres.se/",
  },
  {
    title: "Special Fälgar",
    img: "https://anderssonbilverkstad.se/wp-content/uploads/2020/09/Specialfalgar_Svart_CMYK.jpg",
    url: "https://www.specialfalgar.se/",
  },
  {
    title: "Gummigrossen",
    img: "https://www.gummigrossen.se/Content/images/gummigrossen.jpg",
    url: "https://gummigrossen.se/",
  },
  {
    title: "OCL Brorssons",
    img: "https://h24-original.s3.amazonaws.com/245180/25443862-69dSr.jpg",
    url: "https://www.oclbrorssons.se",
  },
  {
    title: "Broson Wheels    ",
    img: "https://images.eniro.com/yapp/ddbd5c679462dc4f0f923314d9d85a4462e0f22d?name=default",
    url: "https://www.brosonwheels.se/      ",
  },
  {
    title: "Gripen Wheels",
    img: "https://www.gripenwheels.se/upload/loggo-gripen-1.png",
    url: "https://www.gripenwheels.se/",
  },
  {
    title: "AutoSmart",
    img: "https://www.smartab.com/wp-content/uploads/2020/08/Autosmart-Original-Logo_Web.jpg",
    url: "http://www.autosmart.se/",
  },
  {
    title: "Continova",
    img: "https://meritmind.se/wp-content/uploads/2018/10/continova-ab1.jpg",
    url: "https://www.continova.se/",
  },
  {
    title: "Boab",
    img: "https://images.eniro.com/yapp/9d99a542422248b79da503a6927e7a365111dd9e?name=default",
    url: "http://www.boabhjuldelar.se/",
  },
];

const öppettider = [
  {
    title: "Måndag",
    text: "07:00-16:00",
  },
  {
    title: "Tisdag",
    text: "07:00-16:00",
  },
  {
    title: "Onsdag",
    text: "07:00-16:00",
  },
  {
    title: "Torsdag",
    text: "07:00-18:00",
  },
  {
    title: "Fredag",
    text: "07:00-16:00",
  },
  {
    title: "Lördag",
    text: "Stängt",
  },
  {
    title: "Söndag",
    text: "Stängt",
  },
  {
    title: "Röda dagar",
    text: "Stängt",
  },
];

const personal = [
  {
    title: "Victor Holmgren",
    text: "KONTOR & VERKSTAD",
    text2: "Ägare",
    img: "https://static.wixstatic.com/media/3a04ff_d0ae09f0837c4f38aeaadfc15a03bbb4~mv2_d_2576_1680_s_2.jpg/v1/fill/w_476,h_330,al_c,q_80,usm_0.66_1.00_0.01/3a04ff_d0ae09f0837c4f38aeaadfc15a03bbb4~mv2_d_2576_1680_s_2.webp",
  },
  {
    title: "Marcus Rydell",
    text: "KONTOR & VERKSTAD",
    text2: "Ägare",
    img: "https://static.wixstatic.com/media/3a04ff_361620eb3473461a8f71843aa1c27286~mv2_d_3000_2000_s_2.jpg/v1/fill/w_476,h_330,al_c,q_80,usm_0.66_1.00_0.01/3a04ff_361620eb3473461a8f71843aa1c27286~mv2_d_3000_2000_s_2.webp",
  },
  {
    title: "Anders Hådén ",
    text: "REKONDITIONERARE",
    text2: "Anställd",
    img: "https://static.wixstatic.com/media/3a04ff_5efdf651796d468985103d3ca5a79bce~mv2_d_2342_1874_s_2.jpg/v1/fill/w_476,h_330,al_c,q_80,usm_0.66_1.00_0.01/3a04ff_5efdf651796d468985103d3ca5a79bce~mv2_d_2342_1874_s_2.webp",
  },
  {
    title: "Timmy Nordin",
    text: "VERKSTAD",
    text2: "Anställd",
    img: "https://static.wixstatic.com/media/3a04ff_866539855b204838b34e9390cd23e519~mv2_d_1990_1638_s_2.jpg/v1/fill/w_476,h_330,al_c,q_80,usm_0.66_1.00_0.01/3a04ff_866539855b204838b34e9390cd23e519~mv2_d_1990_1638_s_2.webp",
  },
];

const kontakt = [
  {
    icon: "./images/location.png",
    title: "Address",
    text: "Ortviksvägen 39",
    text2: "85633 Sundsvall",
  },
  {
    icon: "./images/time.png",
    title: "Öppettider",
    text: "Mån - Fre",
    text2: "07.00 - 16.00",
  },
  {
    icon: "./images/call.png",
    title: "Telefon",
    text: "060-619135    ",
  },
  {
    icon: "./images/email.png",
    title: "E-post",
    text: "info@sedack.se    ",
  },
];

export {
  navLinks,
  sectionTwo,
  sectionThree,
  socialMedia,
  boka,
  däckPrisLista,
  rekondPrisLista,
  leverantörer,
  öppettider,
  personal,
  kontakt,
  headerData,
};

export const openingHoursData = [
  {
    title: "Måndag",
    text: "07 - 16",
  },
  {
    title: "Tisdag",
    text: "07 - 16",
  },
  {
    title: "Onsdag",
    text: "07 - 16",
  },
  {
    title: "Torsdag",
    text: "07 - 18",
  },
  {
    title: "Fredag",
    text: "07 - 16",
  },
  {
    title: "Lördag",
    text: "Stängt",
  },
  {
    title: "Söndag",
    text: "Stängt",
  },
];

export const washData = [
  {
    title: "VIP-tvätt    ",
    price: "700:-",
    one: "Avfettning",
    two: "schamponering",
    three: "fälg & däck",
    four: "torkning",
    time: "25 min",
  },

  {
    title: "Invändig rekond    ",
    price: "2400:-",
    one: "Avfettning",
    two: "schamponering",
    three: "fälg & däck",
    four: "torkning",
    time: "25 min",
  },
  {
    title: "Lackförsegling    ",
    price: "3000:-",
    one: "Avfettning",
    two: "schamponering",
    three: "fälg & däck",
    four: "torkning",
    time: "25 min",
  },
  {
    title: "Helrekond",
    price: "3900:-",
    one: "Avfettning",
    two: "schamponering",
    three: "fälg & däck",
    four: "torkning",
    time: "25 min",
  },
];

export const däckData = [
  {
    title: "Däckskifte",
    price: "fr. 295:-",
    one: "Mönsterdjup",
    two: "Lufttryck",
    three: "Lorem",
    four: "lorem",
    time: "15 min",
  },
  {
    title: "Montering",
    price: "fr. 150:-",
    one: "Små till 24” hjul",
    two: "Säkert och snabbt",
    three: "lorem",
    four: "lorem",
    time: "25 min",
  },
  {
    title: "Balansering",
    price: "fr. 150:-",
    one: "Rengörning",
    two: "Balansvikter",
    three: "Slut inspektion",
    four: "Lorem",
    time: "30 min",
  },
  {
    title: "Balansering",
    price: "fr. 150:-",
    one: "Rengörning",
    two: "Balansvikter",
    three: "Slut inspektion",
    four: "Lorem",
    time: "30 min",
  },
];

export const däckverkstadsData = [
  {
    price1: "Boka från 600:-",
    price2: "Boka från 2000:-",
    price3: "Boka från 4000:-",
    img: "./images/wheel.png",
    img2: "./images/lug.png",
    img3: "./images/balance.png",
    headingImg: "./images/stacked.jpg",
    heading: "SÅ HÄR FUNGERAR DET",
    title: "DÄCKSKIFTE",
    text: "Medans du väntar skiftar vi dina däck. När du bokat ett däckskiftehos oss bör du ha med dig alla ev. extra bultar och eventuell låsbult. Detta för att vi ska kunna på ett snabbt och effektivt sätt skifta däcken.",
    title2: "MONTERING",
    text2:
      "Med hjälp av nya moderna maskiner monterar vi säkert, snabbt och medhögsta precision alla typer av däck. Vi monterar allt från små däcktill känsliga 24”´s hjul. Med den senaste tekniken undviker vi såkallade monteringsskador som lätt kan uppstå då dagens däck blirallt känsligare.",
    title3: "BALANSERING",
    text3:
      "Med hjälp av moderna maskiner balanserar vi dina hjul så du slipper obalans i hjul, ratt och bil.",
  },
];

export const däckOchFälgData = [
  {
    price1: "Kontakta oss för mer info",
    price2: "Kontakta oss för mer info",
    price3: "Kontakta oss för mer info",
    img: "./images/testare.png",
    img2: "./images/rim.png",
    img3: "./images/car.png",
    headingImg: "./images/rims.jpg",
    heading: "ALLT IFRÅN NYTT TILL BEGAGNAT",
    title: "DÄCK",
    text: "Hos oss hittar ni kvalitetsdäck av kända märken som Continental, Gislaved, Nokian, Michelin, Pirelli, Vredestein, Dunlop, Bridgestone, Hankook. Givetvis har vi också budgetdäck tex Sailun, Antares som vi sålt en massa år nu och har bara bra erfarenhet av.",
    title2: "FÄLG",
    text2:
      "Oavsett om du är ute efter ett par klassiska, sportiga eller andra specifika fälgar så kan vi hjälpa dig på vägen till dina nya fälgar. Det är dessutom mycket som ska stämma överens när det kommer till montering av nya fälgar. ",
    title3: "BEGAGNAT",
    text3:
      "Vi har begagnade kompletta hjul, däck och fälgar till diverse bilar. Bland annat BMW, Saab, Audi, Passat, Volvo mm. Ring gärna för aktuella priser och saldo.",
    subHeading:
      "  Vi erbjuder däck & fälg till alla bilar i olika prisklasser. Vi  jobbar tillsammans med välkända och pålitliga leverantörer som Bridgestone, Nokian, Specialfälgar, OCL Brorssons & Rautamo. Vänligen kontaka oss så tar vi tillsammans fram något som passar just dig och din bil.",
  },
];

export const tvattOchRekondData = [
  {
    price1: "Boka från 600:-",
    price2: "Boka från 2000:-",
    price3: "Boka från 4000:-",
    img: "./images/sponge.png",
    img2: "./images/maintenance.png",
    img3: "./images/clean.png",
    headingImg: "./images/wash2.jpg",
    heading: "SÅ HÄR FUNGERAR DET",
    title: "UTVÄNDIG HANDTVÄTT",
    text: "Avfettning, högtrycksspolning, schamponering, handtvätt, fälg & däckrengöring, rengöring av mattor & dörrgångar samt torkning.",
    title2: "MOTORTVÄTT",
    text2:
      "Vid motortvätten avfettas motorutrymmet och motorns delar så de blir fria från fett och olja. Vi undviker att rengöra eller spola vatten direkt på bilens elektronik. ",
    title3: "VIP-TVÄTT",
    text3:
      "Avfettning, högtryckspolning, schamponering, handtvätt, fälg & däck rengöring, torkning, rengöring av gummimattor & dörrgångar, paneler, dörrsidor, dammsugning av interiör & bagageutrymmet samt fönsterputs.    ",
    subHeading:
      "Vår tvätt & rekond finns tillgänglig för dig året om. Vi utför allt ifrån enklare tvättare till hel rekonditionering och lackförseglningar, kontakta oss gärna om du har några speciella önskemål.",
  },
];

export const dackHotellData = [
  {
    price1: "Boka från 790:-",
    price2: "",
    price3: "",
    img: "./images/wheel.png",
    img2: "./images/thermometer.png",
    img3: "./images/guaranteed.png",
    headingImg: "./images/tires2.jpg",
    heading: "FÖRVARA DINA DÄCK HOS SE DÄCK",
    title: "DÄCKHOTELL",
    text: "Hos oss förvarar du dina däck efter dina behov och önskemål. Utöver däckförvaring kan vi byta däcken och kontrollera deras skick. Om du behöver nya däck kontaktar vi dig i god tid innan det är dags att byta däcken. Däckhotellet kontrollerar lufttrycket, möjlighet för balansering och tvätt av hjulen finns.",
    title2: "RÄTT FÖRVARING",
    text2:
      "När däcken förvaras på rätt sätt håller de längre. Däcken måste skyddas mot direkt solljus och mot starkt neonljus. Däcken måste även skyddas mot fukt och för hög värme. På vårt däckhotell råder optimala förvaringsförhållanden för dina däck. Dessutom sparar du tid och besvär.      ",
    title3: "FÖRSÄKRADE",
    text3:
      "Dina däck är försäkrade och enligt försäkringsbolagens regler så är det din bils försäkring som gäller. Skulle något inträffa med dina däck under tiden vi förvarar dem så ersätter vi din självrisk.      ",
  },
];
